import { render, staticRenderFns } from "./BlackGradationButton.vue?vue&type=template&id=fd25b6ca&scoped=true&"
import script from "./BlackGradationButton.vue?vue&type=script&lang=js&"
export * from "./BlackGradationButton.vue?vue&type=script&lang=js&"
import style0 from "./BlackGradationButton.vue?vue&type=style&index=0&id=fd25b6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd25b6ca",
  null
  
)

export default component.exports